<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <!-- fields parameters -->
      <div class="row">        
        <!-- parametry plus button -->
        <!-- <div class="col-lg-11 col-md-12 col-12"> -->

        <div class="col-lg-2 col-md-12 col-12 ">
          <div class="form-group">
            <label>File name</label>
            <input type="text" class="form-control" placeholder="filename.." [(ngModel)]="currentFile.fileLockerFileName">
          </div>
        </div>

        <div class="col-lg-2 col-md-12 col-12">
          <div class="form-group">
            <label>Aliase</label>
            <input type="text" class="form-control" placeholder="aliases.." [(ngModel)]="currentFile.alias">
          </div>
        </div>

        <div class="col-lg-1 col-md-12 col-12">
          <div class="form-group">
            <label >Leads</label>
            <input type="number" min="1" class="form-control digits" placeholder="leads.." [(ngModel)]="currentFile.leads">
          </div>
        </div>

        <div class="col-lg-4 col-md-12 col-12">
          <div class="form-group">
            <label>Redirect</label>
            <input type="text" class="form-control" placeholder="redirect.." [(ngModel)]="currentFile.redirection">
          </div>
        </div>

        <div class="col-lg-2 col-md-12 col-12">                   
          <label for="domain">Domain</label>
          <select class="form-select" id="domain" [(ngModel)]='currentFile.domain'>
            <option value="1">https://fileskeep.com</option>
            <option value="2">https://filesstorm.com</option>
            <option value="3">https://filescloud.org</option>
            <option value="4">https://fileston.com</option>
          </select>                                
        </div>

        <!-- screeny dla każdej domeny  -->
        <div class="col-lg-1 col-md-12 col-12">
          <label ></label>
          <div class="avatars square-avtar" ngbTooltip="click to zoom" (click)="onDomain()">
            <div class="avatar ratio" *ngIf="currentFile.domain == 1"><img class="b-r-8 height-50" src="assets/images/domain/fileskeep.jpg" alt="#"></div>
            <div class="avatar ratio" *ngIf="currentFile.domain == 2"><img class="b-r-8 height-50" src="assets/images/domain/filesstorm.jpg" alt="#"></div>
            <div class="avatar ratio" *ngIf="currentFile.domain == 3"><img class="b-r-8 height-50" src="assets/images/domain/filescloud.jpg" alt="#"></div>
            <div class="avatar ratio" *ngIf="currentFile.domain == 4"><img class="b-r-8 height-50" src="assets/images/domain/fileston.jpg" alt="#"></div>
          </div>
        </div>
      
      </div>

      <!-- buttons -->
      <div class="row">
        <div class="btn-showcase col-lg-5 col-md-12 col-12 form-group">
          <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="update data" (click)="onUpdate()">
              Update</button>
          <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="delete selected locker" (click)="onDelete()">
              Delete</button>
          <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="add new locker" (click)="onAdd()">
            <i class="fa fa-plus" aria-hidden="true"></i>Add</button>
        </div>

      </div>
    </div>
  </div>

  <!-- lista plików tablica -->
  <div class="col-lg-12 col-md-12 col-12">
    <div class="card">
      <div class="card-body custom-datatable">
          <ngx-datatable
          class='bootstrap'
          [rows]="filesData"
          [columnMode]="ColumnMode.flex"
          [headerHeight]="50"
          [footerHeight]="50"
          [rowHeight]="'auto'"
          [limit]="page.size"
          [count]="page.totalElements"
          [offset]="page.pageNumber"
          [externalPaging]="true"
          (page)="setPage($event)"
          [selected]="selected"
          [selectionType]="SelectionType.single"
          (select)="onSelect($event)"
        >

        <ngx-datatable-column name="date" [flexGrow]="1">
          <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
            <span class="myHeader txt-primary" (click)="sort()">Date</span>
            </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.creationDateUtc | date:'d/MM/yyyy'}}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="lockerFileName" [flexGrow]="2">
          <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
            <span class="myHeader txt-primary" (click)="sort()">File name</span>
            </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.lockerFileName }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="alias" [flexGrow]="2">
          <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
            <span class="myHeader txt-primary" (click)="sort()">Alias</span>
            </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.alias }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="leads" [flexGrow]="1">
          <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
            <span class="myHeader txt-primary" (click)="sort()">Leads</span>
            </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.leads }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="redirection" [flexGrow]="3">
          <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
            <span class="myHeader txt-primary" (click)="sort()">Redirect</span>
            </ng-template>
          <ng-template let-row="row" ngx-datatable-cell-template>
            {{ row.redirection }}
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="domain.name" [flexGrow]="2">
          <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
            <span class="myHeader txt-primary" (click)="sort()">Domain</span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.domain.name}}
          </ng-template>
        </ngx-datatable-column>

        </ngx-datatable>
      </div>
    </div>
  </div>

</div>
<!-- Container-fluid Ends-->
